import { Observable, Subscribable, SubscribableOrValue } from "knockout";

const { defaultTopicIconColor: iconColor } = settings;

export interface EntityIconConfig {
    icon: SubscribableOrValue<string>,
    color: SubscribableOrValue<string>,
    backgroundColor?: SubscribableOrValue<string | undefined>,
    borderColor?: SubscribableOrValue<string | undefined>,
    style?: SubscribableOrValue<number | undefined>
}

export default class EntityIcon {
    icon: Observable<string>
    color: Observable<string>
    backgroundColor: Observable<string>
    backgroundGradient: Observable<string>
    borderColor: Observable<string>
    style: Observable<number>

    isCircleIcon: Subscribable<boolean>

    constructor(config: EntityIconConfig) {
        this.icon = ko.observable(config.icon).unwrap();
        this.color = ko.observable(config.color).unwrap().default(iconColor);
        this.backgroundColor = ko.observable(config.backgroundColor).unwrap().default('none');
        this.borderColor = ko.observable(config.borderColor).unwrap().default('none');
        this.style = ko.observable(config.style).unwrap().default(enums.ActivityIconStyles.Default.value);

        this.isCircleIcon = this.style.is(enums.ActivityIconStyles.Circle.value);

        this.backgroundGradient = ko.observable(this.backgroundColor() != 'none' ? this.backgroundColor() : '');
        if(this.style() != enums.ActivityIconStyles.Default.value && this.backgroundColor() !== 'none') {
            const baseColor = this.backgroundColor();
            const darkenColor = system.lightenDarkenColor(baseColor, -5);
            this.backgroundGradient(`linear-gradient(45deg, ${baseColor} 0%, ${darkenColor} 100%)`);
        }
    }
}